export const Check = (props : any) => {
    return (
        <svg width={props.width || "16"} height={props.height || "12"} viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.6652 0.335376C16.1116 0.781829 16.1116 1.5033 15.6652 1.94975L6.52179 11.0931C6.07534 11.5396 5.35387 11.5396 4.90742 11.0931L0.334733 6.52144C-0.111578 6.07498 -0.111578 5.35351 0.334733 4.90706C0.781115 4.46061 1.50473 4.46061 1.95118 4.90706L5.68246 8.66798L14.0508 0.335376C14.4972 -0.111792 15.2187 -0.111792 15.6652 0.335376Z" fill={props.color || "#2EC959"} />
        </svg>
    );
}
